import { Sprite, Texture, Transform } from 'pixi.js';

import SocialArtifact from 'entity/SocialArtifact';
/**
 * @deprecated - use Sprite
 */
export default class SocialArtifactSprite extends Sprite {
  private imageElement: HTMLImageElement;
  public transform!: Transform;

  public constructor(
    private artifact: SocialArtifact,
    private _ratio = 1,
  ) {
    super(new Texture(artifact.imageURI ? Texture.from(artifact.imageURI).baseTexture : Texture.EMPTY.baseTexture));
    this.x = artifact.x ?? 0;
    this.y = artifact.y ?? 0;
    this.width = (artifact.width ?? 0) * this._ratio;
    this.height = (artifact.height ?? 0) * this._ratio;
    this.texture = Texture.EMPTY;

    this.imageElement = document.createElement('img');
    this.imageElement.crossOrigin = 'anonymous';
  }

  /**
   * Get the artifacts size ratio, which is the
   */
  public get ratio(): number {
    return this._ratio;
  }

  public destroy(): void {
    this.imageElement.remove();
    this.texture.destroy(true);
  }
}
